"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreHeading = require("@vfuk/core-heading");
var _SlotWrapper = _interopRequireDefault(require("../../SlotWrapper"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var HeadingSlot = function HeadingSlot(_ref) {
  var heading = _ref.heading,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 2 : _ref$size,
    slotWrapper = _ref.slotWrapper,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  return /*#__PURE__*/_react["default"].createElement(_SlotWrapper["default"], _extends({}, slotWrapper, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }), /*#__PURE__*/_react["default"].createElement(_coreHeading.Heading, _extends({
    size: size,
    weight: 3
  }, heading, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'heading')
  })));
};
HeadingSlot.displayName = "HeadingSlot";
var _default = HeadingSlot;
exports["default"] = _default;
//# sourceMappingURL=HeadingSlot.js.map